import { Component, Input, OnInit } from '@angular/core';
import { AgGridI } from '../../ag-grid/ag-grid.model';
import { AgCustomHeaderComponent } from '../../ag-grid/ag-custom-header/ag-custom-header.component';
import { CommonService } from '../../../services/common.service';
import { AgGridImportCommonErrors } from '../../../../components/import-documents/pages/errors-tab/errors-tab.model';
import { TabsService } from '../../tabs/tabs.service';
import { LabelsName } from '../../../model/enum';
import { CommonTabService } from '../../../services/common-tab.service';
import { ImportDocumentsService } from '../../../../components/import-documents/import-documents.service';
import { PartsListService } from '../../../../components/parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-error-tab',
  templateUrl: './common-error-tab.component.html',
  styleUrls: ['./common-error-tab.component.scss']
})
export class CommonErrorTabComponent implements OnInit {
  dataModel: AgGridI;
  private gridApi!: any;
  isLoading: boolean = false;
  isPreviewTabOpen:boolean=false;
  potentialError: boolean = false;
  importError:boolean = false;
  titles = ['Inventory','Part','OEMExcess','VendorParts','Consignment',];
  enumErrorFiledName = LabelsName;
  dropdownList:any = []
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    };
    flexHeight;
@Input() data:any = {}
  constructor(public commonService : CommonService,public tabsService: TabsService,public commonTabService: CommonTabService,
    public importDocumentsService:ImportDocumentsService,
     public partsListService: PartsListService,
      private router: Router,
  ) {
 }

  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res =>{
      this.flexHeight = "calc(100vh - 290px - " + res +"px" + ")" 
 
   })
   this.partsListService.allPartDropdownList().subscribe((res) => {
    if (res.isSuccess) {
      this.dropdownList = res?.response;
    }
  });

     this.dataModel = AgGridImportCommonErrors;
     this.commonService.getMapData.subscribe((data=>{
      if(data && this.data?.errorData?.rowData && this.data?.activeTab == 3)
       this.setDefaultValuesIfDataExists()
    }));
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
  setDefaultValuesIfDataExists(){
    if(!(this.data?.errorData?.rowData?.length) && !(this.data?.errorData?.duplicateData?.rowData?.length)){
      this.potentialError = this.importError = this.data.errorData.isDuplicate =true;
    }else if(this.data?.errorData?.rowData?.length){
     this.data.errorData.isDuplicate = false;
     this.potentialError = !(this.data?.errorData?.duplicateData?.rowData?.length);
     this.importError = false;
     this.fillErrorTabData()
    }else{
      this.fillErrorTabData()
    }
  }
  fillErrorTabData(){
    let dropdownList: any =this.dropdownList?? []
    const urlSegment:any = this.router?.url?.split('/').pop();
    let fieldMapping:any
    switch(urlSegment){
      case this.titles[0]:
      case this.titles[2]:
      case this.titles[3]:
      case this.titles[4]:
        fieldMapping = {
          'MPN':dropdownList?.mpnList,
          'MFR':dropdownList?.masterManufacturerWithChildrenList,
          'Standard Packaging':dropdownList?.standardPackagingList,
          'Received Packaging':dropdownList?.receivedPackagingList,
          'Received In':dropdownList?.receivedInList,
          'Warehouse':dropdownList?.warehouseList,
          'RoHS':dropdownList?.roHSList,
          'Condition':dropdownList?.inventoryConditionsList,
          'COO':dropdownList?.countryList,
          'UOM':dropdownList?.uomList,
          // 'Date Code Year':dropdownList?.devicePackagingList,
          // 'Date Code Week':dropdownList?.temperatureGradeList,
        };

      break;
      case this.titles[1]:
         fieldMapping = {
          'MFR':dropdownList?.masterManufacturerWithChildrenList,
          'Part Status':dropdownList?.partStatusList,
          'Standard Packaging':dropdownList?.standardPackagingList,
          'Device Packaging':dropdownList?.devicePackagingList,
          'Temp Grade':dropdownList?.temperatureGradeList,
          'Mount Type':dropdownList?.mountTypeList,
        };
      break;
      // case this.titles[2]:
      // break;
      // case this.titles[3]:
      // break;
    }

  
  this.data?.errorData?.rowData?.forEach(a => {
    const fieldList = fieldMapping[a.errorField];
    a.map = fieldList?.map(item => item.name) || [];
    a.mappedColumn = '';
    a.status = a.status;
  });
  }
  
  reloadData(event){
  }

}
